export default __webpack_public_path__ + "static/media/portfolio-05.061e8719.jpg";